import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { authActions } from "../../../store/auth";
// import "./render.css";
import "./render.css";
const RenderProcess = () => {
  const [render, setRender] = useState({
    render_progress: 0,
    video_path: "",
  });

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : '';

  const subdomain_name = useSelector((state) => state.auth.product.subdomain_name);

  // console.log(subdomain_name);

  useEffect(() => {
    document.title = `Render Video`;
  });
  const { sendRequest } = useHttp();
  const { camp_id } = useParams();
  const dispatch = useDispatch();

  const [ lead_details, setLeadDetails ] = useState({});
  const [ showCreatePage, setShowCreatePage ] = useState(false);
  const [ showPersonalize, setShowPersonalize ] = useState(true);

  const [ name, setName ] = useState('');


  const responseData = (response) => {
    response = response.body;

    var ldata = response.lead_details;
    setName(response.name);

    console.log(ldata);
    if (ldata) {
      ldata = JSON.parse(ldata);
      console.log(ldata);
      setLeadDetails(ldata);
      setShowCreatePage(true);
      setShowPersonalize(false);
    }
    
    

    if (response.render_progress) {
      setRender((prev) => ({
        ...prev,
        render_progress: response.render_progress,
        video_path: response.video_path,
      }));
    }
    dispatch(authActions.setLoaderStatus({ status: false, loader_text: "" }));
  };

  useEffect(() => {
    dispatch(
      authActions.setLoaderStatus({
        status: true,
        loader_text: "Please wait.. Fetching the campaigns details",
      })
    );

    if (!render.video_path) {
      const interval = setInterval(() => {
        sendRequest(
          { url: endPoints.fetchCampaign + "/" + camp_id, method: "GET" },
          responseData
        );
      }, 5000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item"> 
                
                    <Link to="/">Dashboard</Link>
                
              </li>

              <li className="breadcrumb-item active">Render Status</li>
            </ol>
          </nav>

          <div className="emptyDiv bg-white">
            { logo && <img
              src={logo}
              className="img-fluid"
              alt="img"
              />
            }
            
            {!render.video_path && parseInt(render.render_progress) === 0 && (
              <>
                <h5 className="mb-3">
                  <b>
                    Your video is rendering...(
                    {parseInt(render.render_progress)}
                    %)
                  </b>
                </h5>
                <div className="progress mb-3" id="startProgress">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated indeterminate"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "30%" }}
                  ></div>
                </div>
                <p className="text-muted">
                  <b>Downloading all resources</b>
                </p>
                <p className="text-center text-muted">
                  <b>
                    We are rendering your video. Generally, rendering takes
                    15-20 mins to complete depending on the size of the video.
                    <br />
                    You will receive an email once it is ready or you can watch
                    the video in the
                    
                    { (subdomain_name === "vidwise" )? (
                        <a href={`https://vidwiseai.engageleads.net/mycampaign/${lead_details.campid}`} target="_blank"  rel="noreferrer" > Dashboard</a>
                      ):(subdomain_name === "nicheflick" )? (
                        <a href={`https://nicheflicks.engageleads.net/mycampaign/${lead_details.campid}`} target="_blank"  rel="noreferrer" > Dashboard</a>
                      ):(
                        <Link to="/">
                          {" "}
                          <u>Dashboard</u>
                        </Link>
                    )}


                  </b>
                </p>
              </>
            )}

            {!render.video_path && parseInt(render.render_progress) >= 1 && (
              <>
                <h5 className="mb-3">
                  <b>
                    Your video is rendering...(
                    {parseInt(render.render_progress) >= 100
                      ? "98"
                      : render.render_progress}
                    %)
                  </b>
                </h5>
                <div className="progress mb-3" id="startProgress">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: `${
                        parseInt(render.render_progress) >= 100
                          ? "98"
                          : render.render_progress
                      }%`,
                    }}
                  ></div>
                </div>
                <p className="text-muted">
                  <b>
                    {parseInt(render.render_progress) <= 81 &&
                      "Converting scene to video..."}
                    {parseInt(render.render_progress) === 85 &&
                      "Merging all video..."}
                    {parseInt(render.render_progress) === 90 &&
                      "Downloading audio..."}
                    {parseInt(render.render_progress) === 93 &&
                      "Adding audio to video..."}
                    {parseInt(render.render_progress) === 95 &&
                      "Preparing uploading video..."}
                    {parseInt(render.render_progress) === 97 &&
                      "Uploading video..."}
                    {parseInt(render.render_progress) >= 100 &&
                      "Creating GIF for your video..."}
                  </b>
                </p>

                <p className="text-center text-muted">
                  <b>
                    We are rendering your video. Generally, rendering takes
                    15-20 mins to complete depending on the size of the video.
                    <br />
                    You will receive an email once it is ready or you can watch
                    the video in the
                    <Link to="/">
                      {" "}
                      <u>Dashboard</u>
                    </Link>
                  </b>
                </p>
              </>
            )}

            {render.video_path && (
              <>
                <h5 className="mt-3">
                  <b>{name}</b>
                </h5>
                <h5 className="p-3 mb-2">
                  <b>Video Created Successfully</b>
                </h5>
                <div className="bx_a text-center render_video">
                  <div className="series_vd position-relative">
                    <video style={{ width: "100%", height: "300px" }} controls>
                      <source src={render.video_path} />
                    </video>

                    <a
                      href={render.video_path}
                      download={render.video_path}
                      className="btn btn-block text-center"
                    >
                      Click Here To Download Video
                    </a>
                    <p className="m-2">
                      <b>(OR)</b>
                    </p>
                    
                    {
                      showPersonalize && (
                        <Link
                          to={`/video/view/${camp_id}`}
                          className="btn btn-block text-center"
                        >
                          Click Here To Personalize Your Video
                        </Link>
                      )
                    }


                    { showCreatePage && ( subdomain_name === 'vidwise' ) && (
                        <a
                        href={`https://vidwiseai.engageleads.net/createPage?insert_place_id=${lead_details.campid}&video_url=${render.video_path}`}
                        className="btn btn-block text-center"
                        target="_blank"
                        rel="noreferrer"
                        >
                          Click Here To Create Your Landing Page
                        </a>
                      )
                    }

                    { showCreatePage && ( subdomain_name === 'nicheflick' ) && (
                        <a
                        href={`https://nicheflicks.engageleads.net/createPage?insert_place_id=${lead_details.campid}&video_url=${render.video_path}`}
                        className="btn btn-block text-center"
                        target="_blank"
                        rel="noreferrer"
                        >
                          Click Here To Create Your Landing Page
                        </a>
                      )
                    }

                      
                  </div>
                </div>
              </>
            )}
            {/* <p>All your created campaign will be saved here</p> */}
          </div>

          <div className="row">
            <div className="col-xl-6 col-lg-7 col-md-12 m-auto"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RenderProcess;
